import { createSlice } from '@reduxjs/toolkit';
import { LOADER } from '../types';

const appSlice = createSlice({
    name: LOADER,
    reducers: {
        setIsLoading(state, action) {
            state.isLoading = action.payload;
        },
        setNotification(state, action) {
            state.notification = action.payload;
        },
        setPageTitle(state, action) {
            state.pageTitle = action.payload;
        },
        setCompress(state, action) {
            state.compress = action.payload;
        }
    },
    initialState: {
        isLoading: false,
        notification: false,
        pageTitle: '',
        compress: false
    }
});

export const { setIsLoading, setNotification, setPageTitle, setCompress } = appSlice.actions;

export const appReducer = appSlice.reducer;
